import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import {
  Home as HomeIcon,
  MenuBook,
  Receipt,
  Dashboard as DashboardIcon,
  MoreHoriz,
} from '@mui/icons-material';

/**
 * Mobile bottom navigation bar.
 * Tabs: Home | Menus | Orders | Dashboard | More
 * Cart is removed from nav bar — it's now a floating button.
 */
export const MobileBottomNavNew = ({ activeTab, onTabChange }) => {
  const tabs = [
    { key: 'home', label: 'Home', icon: <HomeIcon /> },
    { key: 'menus', label: 'Menus', icon: <MenuBook /> },
    { key: 'orders', label: 'Orders', icon: <Receipt /> },
    { key: 'dashboard', label: 'Dashboard', icon: <DashboardIcon /> },
    { key: 'more', label: 'More', icon: <MoreHoriz /> },
  ];

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1200,
        bgcolor: 'rgba(255, 255, 255, 0.78)',
        backdropFilter: 'blur(20px) saturate(180%)',
        WebkitBackdropFilter: 'blur(20px) saturate(180%)',
        boxShadow: '0 -1px 12px rgba(0,0,0,0.04)',
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        py: 0.5,
        px: 1,
        pb: 'calc(8px + env(safe-area-inset-bottom, 0px))',
      }}
    >
      {tabs.map((tab) => {
        const isActive = activeTab === tab.key;
        return (
          <Box
            key={tab.key}
            onClick={() => onTabChange(tab.key)}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              cursor: 'pointer',
              flex: 1,
              py: 0.5,
              color: isActive ? '#4527A0' : '#86868B',
              transition: 'color 0.2s',
            }}
          >
            <IconButton
              size="small"
              sx={{ color: 'inherit', p: 0.5 }}
            >
              {tab.icon}
            </IconButton>
            <Typography
              sx={{
                fontSize: '0.62rem',
                fontWeight: isActive ? 700 : 500,
                color: 'inherit',
                lineHeight: 1,
                mt: 0.25,
              }}
            >
              {tab.label}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};
